import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const getInviteAndRegisteredUsersApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunction(data, apiConstants.USER.GET_INVITE_AND_REGISTERED_USERS)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
